{
  "creating_subtitle": "This will only take a moment",
  "creating_account": "Setting up your account...",
  "error_title": "Oops! Something went wrong",
  "try_again": "Try Again",
  "first_name_label": "First name",
  "first_name_placeholder": "Enter your first name here",
  "error_generic": "Something went wrong. Please try again.",
  "create_user_failed": "Failed to create user account",
  "missing_name_title": "What's your name?",
  "missing_name_subtitle": "We need your first name to finish setting up your account.",
  "missing_name_continue": "Continue"
}
